import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import {
  CheckCanReferRequest,
  ExistingAdviserReferralMetadataRequest,
  ReferralApprovalMetadataRequest,
} from '@/types/requests/referral-metadata'
import {
  CheckCanReferItem,
  ExistingAdviserReferralMetadataItem,
  NewAdviserReferralMetadataItem,
} from '@/types/responses/referral-metadata'

class ReferralMetadataService {
  private endpoint = `${API_PATH_INTERNAL}/referral-metadata`

  async checkCanRefer(
    request: CheckCanReferRequest,
  ): Promise<CheckCanReferItem> {
    const response = await apiService.post(
      `${this.endpoint}/check-can-refer`,
      request,
    )

    return response.data
  }

  async createExistingAdviserReferralMetadata(
    request: ExistingAdviserReferralMetadataRequest,
  ): Promise<ExistingAdviserReferralMetadataItem> {
    const response = await apiService.post(
      `${this.endpoint}/existing-adviser-referral`,
      request,
    )

    return response.data
  }

  async createNewAdviserReferralMetadata(): Promise<NewAdviserReferralMetadataItem> {
    const response = await apiService.post(
      `${this.endpoint}/new-adviser-referral`,
      {},
    )

    return response.data
  }

  async createApprovalRequestMetadata(
    request: ReferralApprovalMetadataRequest,
  ) {
    const response = await apiService.post(
      `${this.endpoint}/approval-request`,
      request,
    )

    return response.data
  }
}

const referralMetadataService = new ReferralMetadataService()

export default referralMetadataService
